var _path, _linearGradient, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c767e5",
    d: "M36,6H12c-3.314,0-6,2.686-6,6v24c0,3.314,2.686,6,6,6h24c3.314,0,6-2.686,6-6V12 C42,8.686,39.314,6,36,6z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eCzMVa~gw8dr5MHqWyNHVa",
    x1: 8,
    x2: 40,
    y1: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7819a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771aa9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eCzMVa~gw8dr5MHqWyNHVa)",
    d: "M36,40H12c-2.209,0-4-1.791-4-4V12c0-2.209,1.791-4,4-4h24c2.209,0,4,1.791,4,4v24 C40,38.209,38.209,40,36,40z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.209,31.946h-2.334c-0.204,0-0.387-0.124-0.464-0.313l-2.102-5.206 c-0.084-0.205-0.171-0.583-0.262-1.135h-0.036c-0.042,0.261-0.142,0.654-0.298,1.182l-2.11,5.161 c-0.077,0.188-0.26,0.311-0.463,0.311h-2.339c-0.369,0-0.611-0.387-0.45-0.719l3.672-7.544c0.065-0.133,0.067-0.287,0.007-0.422 l-3.364-7.557C13.52,15.373,13.762,15,14.124,15h2.426c0.21,0,0.398,0.131,0.47,0.329l1.73,4.752 c0.145,0.402,0.274,0.879,0.389,1.43h0.036c0.071-0.326,0.204-0.81,0.398-1.451c0.005-0.016,0.011-0.033,0.017-0.048l1.921-4.7 C21.587,15.123,21.77,15,21.973,15h2.132c0.365,0,0.607,0.378,0.454,0.71l-3.456,7.481c-0.062,0.134-0.061,0.288,0.001,0.421 l3.558,7.622C24.816,31.566,24.574,31.946,24.209,31.946z M33.502,31.723h-1.675c-0.276,0-0.5-0.224-0.5-0.5v-1.055h-0.034 c-0.61,1.221-1.505,1.831-2.684,1.831c-1.084,0-1.956-0.498-2.617-1.495c-0.66-0.997-0.991-2.388-0.991-4.176 c0-1.868,0.365-3.365,1.092-4.49c0.728-1.126,1.682-1.688,2.862-1.688c1.118,0,1.897,0.522,2.338,1.567h0.034v-6.218 c0-0.276,0.224-0.5,0.5-0.5h1.675c0.276,0,0.5,0.224,0.5,0.5v15.724C34.002,31.5,33.778,31.723,33.502,31.723z M31.377,26.229V25.38 c0-0.735-0.164-1.346-0.491-1.831c-0.327-0.485-0.753-0.728-1.278-0.728c-0.593,0-1.056,0.303-1.389,0.91 c-0.333,0.607-0.499,1.44-0.499,2.499c0,0.993,0.161,1.758,0.483,2.295c0.322,0.537,0.768,0.806,1.338,0.806 c0.542,0,0.983-0.283,1.325-0.85C31.207,27.914,31.377,27.163,31.377,26.229z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXd);
export default __webpack_public_path__ + "static/media/xd.363a00e6d73523365c8f8dae43234dd8.svg";
export { ForwardRef as ReactComponent };